import Vue from 'vue';
const EventBusNotification = new Vue();
export { EventBusNotification };